import { render, staticRenderFns } from "./AuthSetPassword.vue?vue&type=template&id=266b46cf&"
import script from "./AuthSetPassword.vue?vue&type=script&lang=js&"
export * from "./AuthSetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('266b46cf')) {
      api.createRecord('266b46cf', component.options)
    } else {
      api.reload('266b46cf', component.options)
    }
    module.hot.accept("./AuthSetPassword.vue?vue&type=template&id=266b46cf&", function () {
      api.rerender('266b46cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/auth/screens/AuthSetPassword.vue"
export default component.exports